<template>
  <v-container v-resize="onResize" class="pb-0">
    <div v-if="selectedMeeting">
      <v-row>
        <v-col cols="12" md="12"> {{ $t("agenda.lblMeetingTimer") }} </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="1" :class="colClasses">
          <v-avatar
            v-if="meetingStatus === 'Started'"
            color="red"
            size="24"
          ></v-avatar>
          <v-avatar v-else class="avatar-circle" size="24"></v-avatar>
        </v-col>
        <v-col cols="7">
          <v-row no-gutters class="mb-2">
            <timer-progress-bar
              :value="timerProgressCalulation"
              :lable="meetingName"
              :color="progressColor"
              :backgroundColor="progressBackgroundColor"
            ></timer-progress-bar>
          </v-row>
          <v-row no-gutters v-if="updateMeetingTimerPermission">
            <timer-actions
              :status="meetingStatus"
              @action="onActionClick($event)"
            ></timer-actions>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row no-gutters>
            <v-text-field
              :value="meetingActualTime"
              outlined
              dense
              hide-details
              background-color="white"
              readonly
            >
            </v-text-field>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col cols="4">
              <time-input
                v-model="startMeetingTime"
                :isTimerRunning="isMeetingTimerRunning"
                @edit="onTimeEdit"
              ></time-input>
            </v-col>
            <v-col cols="2" class="text-center">
              <v-icon size="16">mdi-arrow-right</v-icon>
            </v-col>
            <v-col cols="4">
              <time-input
                v-model="endMeetingTime"
                :isTimerRunning="isMeetingTimerRunning"
                @edit="onTimeEdit"
              ></time-input>
            </v-col>
            <v-col cols="2" class="text-right">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="onDateAction"
                  >
                    <v-icon v-if="isHideDatePicker">mdi-chevron-up </v-icon>
                    <v-icon v-else>mdi-chevron-down </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("agenda.tipUpdateTimerDate") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2" v-if="!isHideDatePicker">
            <start-end-time-date-picker
              :startDate.sync="actualStartDate"
              :endDate.sync="actualEndDate"
              @edit="onTimeEdit"
            ></start-end-time-date-picker>
          </v-row>
        </v-col>
      </v-row>
      <hr class="mt-3" />
      <div id="topicDivId" class="overflow-x-hidden overflow-y-auto pt-4">
        <template v-for="(topic, index) in topics">
          <timer-control
            :ref="`topic_timer_${topic.Id}`"
            :key="`${topic.Id}_${index}`"
            :topic="topic"
            :selectedMeeting="selectedMeeting"
            :index="index"
            :isTimerRunning="isMeetingTimerRunning"
            @timer-run="onTimerRun"
            @updateTime="onUpdateStartEndTime"
            :meetingStartDate="actualStartDate"
            @edit="onTopicTimeEdit"
          ></timer-control>
        </template>
      </div>
      <v-row
        v-if="updateMeetingTimerPermission"
        class="text-right mr-1 pt-5 mb-3"
        style="display: flow"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              class="mr-3"
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="onSync"
            >
              {{ $t("agenda.lblSync") }}
            </a-btn>
          </template>
          <span>{{ $t("agenda.lblTipSync") }} </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              :disabled="isMeetingTimerRunning || !isTimeEdit"
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="onSaveResult"
            >
              {{ $t("agenda.lblSaveResult") }}
            </a-btn>
          </template>
          <span>{{ $t("agenda.lblSaveTimerResult") }}</span>
        </v-tooltip>
      </v-row>
    </div>
    <confirm-dialog ref="confirm" />
    <message-sheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="closeMessageSheet"
    ></message-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TimerActions from "./TimerActions.vue";
import TimerControl from "./TimerControl.vue";
import TimerProgressBar from "./TimerProgressBar.vue";
import SignalRMixin from "../../../mixin/SignalRMixin";
import TimeInput from "./TimeInput.vue";
import ConfirmDialog from "../../ConfirmDialog.vue";
import { cloneDeep } from "lodash";
import MessageSheet from "../../MessageSheet.vue";
import {
  calculateSecondsFromGivenUTCToCurrent,
  secondsToHMS,
  convertTimeToDate,
  convertDateToTime,
} from "../../../utils/util";
import StartEndTimeDatePicker from "./StartEndTimeDatePicker.vue";

export default {
  components: {
    TimerActions,
    TimerProgressBar,
    TimerControl,
    TimeInput,
    ConfirmDialog,
    MessageSheet,
    StartEndTimeDatePicker,
  },
  name: "MeetingTopicTimer",
  mixins: [SignalRMixin],
  props: {
    meetingId: String,
  },
  data() {
    return {
      isHideDatePicker: true,
      displayMessage: false,
      message: "",
      messageType: "",
      topicsHeight: 0,
      inlineUpdateTime: [],
      mettingTimerCounter: 0,
      selectedMeeting: null,
      elapsedTime: 0,
      topics: [],
      startTime: "0",
      endTime: "0",
      status: null,
      isTimerRunning: false,
      instanceId: null,
      progressTimer: 0,
      timerInterval: null,
      isAnyTimerRunning: false,
      mStartDate: new Date(),
      mEndDate: new Date(),
      pauseTime: null,
      totalPauseTime: 0,
      isTimeEdit: false,
      editedTopicList: [],
      refSavedMeetingData: null,
    };
  },
  computed: {
    ...gettersMap(),
    updateMeetingTimerPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeetingTimer"
        );
      }
      return false;
    },
    meetingName() {
      return this.selectedMeeting
        ? this.selectedMeeting.meetingName
        : "loading";
    },
    actualTotalTimeInSecond() {
      if (!this.selectedMeeting) return null;

      const startTime = new Date(this.selectedMeeting.scheduletStartTimeInUTC);
      const endTime = new Date(this.selectedMeeting.scheduledEndTimeInUTC);

      const timeDiffInMilliseconds = endTime - startTime;
      const timeDiffInMinutes = Math.round(
        timeDiffInMilliseconds / (1000 * 60)
      );

      return timeDiffInMinutes;
    },
    actualStartDate: {
      get() {
        return this.startTime ? new Date(this.startTime) : this.mStartDate;
      },
      set(value) {
        this.mStartDate = new Date(value);
        this.mEndDate = new Date(value);

        if (this.startTime) {
          this.startTime = updateDate(this.mStartDate, this.startTime);
        }
      },
    },
    actualEndDate: {
      get() {
        return this.endTime ? new Date(this.endTime) : this.mEndDate;
      },
      set(value) {
        this.mEndDate = new Date(value);
        if (this.endTime) {
          this.endTime = updateDate(this.mEndDate, this.endTime);
        }
      },
    },
    meetingDuration() {
      let start = new Date(this.selectedMeeting.scheduletStartTimeInUTC);
      let end = new Date(this.selectedMeeting.scheduledEndTimeInUTC);
      var timeDiff = end - start;
      return timeDiff / 60 / 1000;
    },
    meetingActualTime() {
      if (this.selectedMeeting && this.actualTotalTimeInSecond) {
        return `${secondsToHMS(this.progressTimer)} / ${Number(
          this.actualTotalTimeInSecond
        ).toFixed(0)} min`;
      }
      return "loading...";
    },
    startMeetingTime: {
      get() {
        return this.startTime ? convertDateToTime(this.startTime) : null;
      },
      set(value) {
        const setDate = this.startTime || this.mStartDate;
        this.startTime = convertTimeToDate(setDate, value);
      },
    },
    endMeetingTime: {
      get() {
        return this.endTime ? convertDateToTime(this.endTime) : null;
      },
      set(value) {
        const setDate = this.endTime || this.mStartDate;
        this.endTime = convertTimeToDate(setDate, value);
      },
    },
    meetingStatus() {
      return this.status;
    },
    progressColor() {
      return this.getProgressBackgroundColor();
    },
    progressBackgroundColor() {
      return this.progressColor + " lighten-4";
    },
    meetingStartDate() {
      return this.selectedMeeting
        ? new Date(this.selectedMeeting.scheduletStartTimeInUTC)
        : new Date();
    },
    meetingEndDate() {
      return this.selectedMeeting
        ? new Date(this.selectedMeeting.scheduledEndTimeInUTC)
        : new Date();
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    timerProgressCalulation() {
      return ((this.progressTimer / 60) * 100) / this.meetingDuration;
    },
    isMeetingTimerRunning() {
      if (!this.updateMeetingTimerPermission) {
        return true;
      }
      return this.isTimerRunning || this.isAnyTimerRunning;
    },
    colClasses() {
      return {
        "d-flex": this.updateMeetingTimerPermission,
        "justify-center": true,
        "align-center": true,
        "text-center": true,
      };
    },
  },
  async mounted() {
    try {
      await this.getTenantConfigList();
      this.signalRInit(`newMessage_MeetingTimer_${this.meetingId}`);
      const target = "meeting_" + this.selectedTenant;
      const updteMeetingTimerSignalRTarget =
        "Save_MeetingTimer_" + this.meetingId;
      this.signalMeetingUpdate(updteMeetingTimerSignalRTarget); // Commented for voting Enhancement issue
      this.signalMeetingDetailsUpdate(target);
      await this.bindMeetingDetails();
      this.timerStartOnMounted();
      this.onResize();
      document.addEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
    } catch (error) {
      console.log(error, "API error");
    }
  },
  beforeDestroy() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  },
  watch: {
    meetingStartDate(value) {
      if (value) {
        this.mStartDate = value;
      }
    },
    meetingEndDate(value) {
      if (value) {
        this.mEndDate = value;
      }
    },
  },
  methods: {
    ...mapActions({
      getMeetingDetails: "meeting/getMeetingById",
      updateTimer: "timer/updateTimer",
      saveTimer: "timer/saveTimer",
      getTenantConfigList: "tenant/getTenantConfigList",
    }),
    onActionClick,
    signalRInit,
    signalMeetingUpdate,
    signalMeetingDetailsUpdate,
    playTopicTimer,
    getProgressBackgroundColor,
    bindMeetingDetails,
    ConfirmTimerReset,
    onSaveResult,
    onTimerRun,
    onUpdateStartEndTime,
    onResize,
    getTopicOrder,
    getTopicsByCategoryOrder,
    generateTimerObjectArray,
    showMessageSheet,
    closeMessageSheet,
    onSync,
    syncMeetingTimer,
    updateMeetingTimer,
    handleMeetingTimer,
    timerStartOnMounted,
    onDateAction,
    handleVisibilityChange,
    onTimeEdit,
    onTopicTimeEdit,
  },
};

function onTopicTimeEdit(id) {
  this.editedTopicList.push(id);
  this.isTimeEdit = true;
}

function onTimeEdit(isEdit) {
  this.isTimeEdit = isEdit;
}

function handleVisibilityChange() {
  if (!document.hidden) {
    this.timerStartOnMounted();
  }
}

function updateDate(newDate, oldDate) {
  const currentDate = new Date(newDate);
  const oldDateTime = new Date(oldDate);

  currentDate.setHours(oldDateTime.getHours());
  currentDate.setMinutes(oldDateTime.getMinutes());

  return currentDate;
}

function onDateAction() {
  this.isHideDatePicker = !this.isHideDatePicker;
}

function timerStartOnMounted() {
  if (this.status === "Started") {
    if (this.startTime) {
      let progressTimer = calculateSecondsFromGivenUTCToCurrent(this.startTime);
      if (this.totalPauseTime > 0) {
        progressTimer = Math.round(
          (Date.now() -
            new Date(this.startTime).getTime() -
            this.totalPauseTime) /
            1000
        );
      }

      this.progressTimer = progressTimer;
    }
    this.playTopicTimer(false);
  }
}

async function syncMeetingTimer() {
  try {
    const data = {
      meeting_id: this.meetingId,
      meetingTypeId: this.selectedMeeting.meetingTypeId,
      timer_type: "MeetingTimer",
      meeting_timer: {
        id: this.meetingId,
        startMeetingTime: this.startTime,
        endMeetingTime: this.endTime,
        timerValue: this.timerProgressCalulation,
        timeCounter: this.progressTimer,
        elapsed: null,
        status: this.status,
        instance_id: null,
        pauseTime: null,
        interval: 0,
        totalPauseTime: this.totalPauseTime,
      },
    };
    await this.updateMeetingTimer(data);
  } catch (error) {
    console.log(error, "api error");
  }
}

async function onSync() {
  try {
    if (
      await this.$refs.confirm.open(
        this.$t("task.lblConfirmation"),
        this.$t("agenda.lblSyncConfirm")
      )
    ) {
      await this.syncMeetingTimer();
      this.topics.forEach((topic, index) => {
        this.$refs[`topic_timer_${topic.Id}`][0].syncTopicTimer();
      });
    }
  } catch (error) {
    console.log(error, "API error");
  }
}

/* new functions */
async function playTopicTimer(isPlayClick) {
  if (!this.isTimerRunning) {
    if (this.status === "Finished") {
      this.progressTimer = 0;
      this.totalPauseTime = 0;
    }
    this.status = "Started";
    if (!isPlayClick) {
      this.timerInterval = setInterval(() => {
        this.progressTimer++;
      }, 1000);
    }
    this.isTimerRunning = true;
  }
}
/* end new functions */

function getTopicOrder(item) {
  if (!this.selectedMeeting || !this.selectedMeeting.topicCategories) {
    return item.order;
  }

  const category = this.selectedMeeting.topicCategories.find(
    (category) => category.id === item.id
  );

  return category ? category.order : item.order;
}

async function onResize() {
  this.topicsHeight = window.innerHeight - 270;
  let topicDiv = await document.getElementById("topicDivId");
  if (this.topicsHeight && topicDiv) {
    topicDiv.style.height = `${this.topicsHeight}px`;
  }
}

function onUpdateStartEndTime(timeDetails) {
  this.inlineUpdateTime = updateObjectById(
    cloneDeep(this.inlineUpdateTime),
    timeDetails.topicId,
    { start_time: timeDetails.start_time, end_time: timeDetails.end_time }
  );
}

function updateObjectById(array, topicId, updatedProperties) {
  // Find the index of the object with the given id
  const index = array.findIndex((obj) => obj.topicId === topicId);
  // If object with id is found, update its properties
  if (index !== -1) {
    array[index] = { ...array[index], ...updatedProperties };
  }
  return array;
}

function onTimerRun(isTimerRunning) {
  this.isAnyTimerRunning = isTimerRunning;
}

async function onSaveResult() {
  try {
    let timer_list = {};
    const { startMeetingTime, endMeetingTime } = this.refSavedMeetingData;

    const isMeetingTimeUpdated =
      new Date(startMeetingTime).getTime() !==
        new Date(this.startTime).getTime() ||
      new Date(endMeetingTime).getTime() !== new Date(this.endTime).getTime();

    if (this.startTime && this.endTime && isMeetingTimeUpdated) {
      timer_list[this.meetingId] = {
        start_time: roundOffDateTimer(this.startTime),
        end_time: roundOffDateTimer(this.endTime),
      };
    }
    this.inlineUpdateTime.forEach((time) => {
      if (
        time.start_time &&
        time.end_time &&
        this.editedTopicList.includes(time.topicId)
      ) {
        timer_list[time.topicId] = {
          start_time: roundOffDateTimer(time.start_time),
          end_time: roundOffDateTimer(time.end_time),
        };
      }
    });
    const obj = {
      meeting_id: this.meetingId,
      meetingTypeId: this.selectedMeeting.meetingTypeId,
      timer_list,
    };
    await this.saveTimer(obj);
    this.isTimeEdit = false;
    this.editedTopicList = [];
    await this.bindMeetingDetails();
    this.timerStartOnMounted();
    this.showMessageSheet(this.$t("agenda.MeetingTimerUpdated"), "success");
  } catch (error) {
    console.log(error, "API error");
  }
}

function roundOffDateTimer(date) {
  const currentDate = new Date(date);
  currentDate.setSeconds(0);
  currentDate.setMilliseconds(0);
  return currentDate;
}

async function ConfirmTimerReset() {
  if (
    await this.$refs.confirm.open(
      this.$t("agenda.timerReset"),
      this.$t("agenda.timerResetMessage"),
      { yesNoButtons: true }
    )
  ) {
    await this.handleMeetingTimer("reset");
  }
}

async function bindMeetingDetails() {
  try {
    this.selectedMeeting = await this.getMeetingDetails(this.meetingId);
    this.refSavedMeetingData = cloneDeep(this.selectedMeeting);
    this.startTime = this.selectedMeeting.startMeetingTime;
    this.endTime = this.selectedMeeting.endMeetingTime;
    this.mettingTimerCounter = this.selectedMeeting.timeCounter;
    this.elapsedTime = this.selectedMeeting.elapsed;
    this.status = this.selectedMeeting.status;
    this.instanceId = this.selectedMeeting.instance_id;
    this.progressTimer = this.selectedMeeting.timeCounter;
    this.pauseTime = this.selectedMeeting.pauseTime;
    this.totalPauseTime = this.selectedMeeting.totalPauseTime;
    this.topics = [];
    this.$nextTick(() => {
      this.topics = this.generateTimerObjectArray();
      this.inlineUpdateTime = [];
      this.topics.forEach((topic) => {
        const timeObj = {
          topicId: topic.Id,
          start_time: topic.starttime,
          end_time: topic.endtime,
        };
        this.inlineUpdateTime.push(timeObj);
      });
    });
  } catch (error) {
    console.log(error, "APFI error");
  }
}

function getTopicsByCategoryOrder() {
  const catTopics = this.tenantSettingTypes("topiccategory").map((item) => ({
    ...item,
    order: this.getTopicOrder(item),
    topics: this.selectedMeeting.topics
      .filter((s) => s.topicCategory === item.id)
      .sort((a, b) => a.displayOrder - b.displayOrder),
  }));
  return catTopics.sort((a, b) => a.order - b.order);
}

function generateTimerObjectArray() {
  let topicArr = [];
  const categorizedTopics = this.getTopicsByCategoryOrder();
  categorizedTopics.forEach((cat) => {
    cat.topics
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .forEach((topic) => {
        let topicObj = Object.assign({}, this.topicObject);
        topicObj.starttime = "-";
        topicObj.endtime = "-";
        topicObj.timeInMinutes = topic.timeInMinutes;
        topicObj.topicName = topic.topicName;
        topicObj.status = "NotStarted";
        topicObj.elapsed = 0;
        topicObj.remaining = topic.timeInMinutes;
        topicObj.endtime = topic.endtime || null;
        topicObj.starttime = topic.starttime || null;
        topicObj.timerValue = topic.timerValue || null;
        topicObj.timeCounter = topic.timeCounter || null;
        topicObj.elapsed = topic.elapsed || null;
        topicObj.status = topic.status || null;
        topicObj.Id = topic.Id || null;
        topicArr.push(topicObj);
      });
  });

  return topicArr.map((item, index) => ({
    index: index,
    ...item,
  }));
}

function getProgressBackgroundColor() {
  if (this.meetingStatus === null) {
    return "white";
  }
  if (this.timerProgressCalulation <= 80) {
    return "success";
  } else if (
    this.timerProgressCalulation > 80 &&
    this.timerProgressCalulation <= 90
  ) {
    return "warning";
  } else if (
    this.timerProgressCalulation > 90 &&
    this.timerProgressCalulation <= 100
  ) {
    return "orange";
  } else {
    return "error";
  }
}

function signalMeetingUpdate(target) {
  this.signalConnection.on(target, async (response) => {
    const tabId = sessionStorage.getItem("tab_id");
    if (response.meeting_id === this.meetingId && response.tab_id !== tabId) {
      await this.bindMeetingDetails();
      this.timerStartOnMounted();
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

function signalMeetingDetailsUpdate(target) {
  this.signalConnection.on(target, async (response) => {
    const tabId = sessionStorage.getItem("tab_id");
    if (response.meeting_id === this.meetingId) {
      await this.bindMeetingDetails();
      this.timerStartOnMounted();
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

function signalRInit(target) {
  this.signalConnection.on(target, async (response) => {
    const tabId = sessionStorage.getItem("tab_id");
    const targetData = response.target_data;
    if (response.tab_id !== tabId) {
      const {
        status,
        timeCounter,
        startMeetingTime,
        endMeetingTime,
        elapsed,
        instance_id,
        pauseTime,
        totalPauseTime,
      } = targetData;
      this.mettingTimerCounter = timeCounter;
      this.startTime = startMeetingTime;
      this.endTime = endMeetingTime;
      this.elapsedTime = elapsed;
      this.status = status;
      this.instanceId = instance_id;
      this.progressTimer = timeCounter;
      this.pauseTime = pauseTime;
      this.totalPauseTime = totalPauseTime;
      if (this.status === "Paused" || this.status === "Finished") {
        clearInterval(this.timerInterval);
        this.isTimerRunning = false;
      }
      if (this.status === "Started") {
        this.playTopicTimer(false);
      }
      if (!this.status) {
        clearInterval(this.timerInterval);
        this.isTimerRunning = false;
      }
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

async function updateMeetingTimer(data) {
  this.status = data.meeting_timer.status;

  const response = await this.updateTimer(data);
  this.refSavedMeetingData = cloneDeep(response);
  const {
    status,
    timeCounter,
    startMeetingTime,
    endMeetingTime,
    elapsed,
    instance_id,
    totalPauseTime,
    pauseTime,
  } = response;
  let progressTimer = timeCounter;
  if (startMeetingTime && totalPauseTime > 0 && status === "Started") {
    progressTimer = Math.round(
      (Date.now() - new Date(startMeetingTime).getTime() - totalPauseTime) /
        1000
    );
  }

  this.mettingTimerCounter = timeCounter;
  this.startTime = startMeetingTime;
  this.endTime = endMeetingTime;
  this.elapsedTime = elapsed;
  this.status = status;
  this.instanceId = instance_id;
  this.progressTimer = progressTimer;
  this.pauseTime = pauseTime;
  this.totalPauseTime = totalPauseTime;

  const isTimerStopped =
    this.status === "Paused" || this.status === "Finished" || !this.status;

  if (isTimerStopped) {
    clearInterval(this.timerInterval);
    this.isTimerRunning = false;
  }

  if (this.status === "Started") {
    this.playTopicTimer(false);
  }
}

async function onActionClick(action) {
  switch (action) {
    case "play":
      this.playTopicTimer(true);
      await this.handleMeetingTimer("start");
      this.timerInterval = setInterval(() => {
        this.progressTimer++;
      }, 1000);
      break;
    case "pause":
      await this.handleMeetingTimer("pause");
      break;
    case "stop":
      await this.handleMeetingTimer("stop");
      break;
    case "reset":
      await this.ConfirmTimerReset();
      break;
    default:
      // Handle any other actions here
      break;
  }
}

async function handleMeetingTimer(action, additionalData = {}) {
  try {
    if (action !== "start") {
      clearInterval(this.timerInterval);
      this.isTimerRunning = false;
    }
    let totalPauseTime = this.totalPauseTime;
    if (action === "start" && this.pauseTime) {
      const pausedDuration = Date.now() - new Date(this.pauseTime).getTime();
      totalPauseTime += pausedDuration;
    }

    const baseData = {
      meeting_id: this.meetingId,
      meetingTypeId: this.selectedMeeting.meetingTypeId,
      timer_type: "MeetingTimer",
      meeting_timer: {
        id: this.meetingId,
        startMeetingTime:
          action === "start"
            ? this.progressTimer > 0
              ? this.startTime
              : new Date().toISOString()
            : action === "reset"
            ? null
            : this.startTime,
        endMeetingTime: action === "stop" ? new Date().toISOString() : null,
        timerValue: action === "reset" ? null : this.timerProgressCalulation,
        timeCounter: action === "reset" ? 0 : this.progressTimer,
        elapsed: null,
        status:
          action === "start"
            ? "Started"
            : action === "pause"
            ? "Paused"
            : action === "stop"
            ? "Finished"
            : null,
        instance_id: null,
        pauseTime: action === "pause" ? new Date().toISOString() : null,
        totalPauseTime: action === "reset" ? 0 : totalPauseTime,
        interval: 0,
        ...additionalData,
      },
    };
    await this.updateMeetingTimer(baseData);
  } catch (error) {
    console.log(error, "API error");
  }
}

function gettersMap() {
  return mapGetters({
    tenantSettingTypes: "tenant/tenantSettingTypes",
    getMeetingTypeId: "meeting/getMeetingTypeId",
  });
}

function showMessageSheet(message, messageType) {
  this.displayMessage = true;
  this.message = message;
  this.messageType = messageType;
}

function closeMessageSheet() {
  this.displayMessage = false;
}
</script>

<style scoped>
.avatar-circle {
  border: 1px solid blue !important;
}

::v-deep.v-text-field .v-input__control .v-input__slot {
  min-height: 30px !important;
  display: flex !important;
  align-items: center !important;
  font-size: 14px;
}
.bg-color {
  background-color: white;
}
</style>